/* eslint-disable no-undef */

import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import { FormHelperText, Grid, TextField } from '@material-ui/core'

// Base styles (theme-based, for all layouts except 'full')
const baseStyles = theme => ({
    errorText: {
        marginTop: theme.spacing(0.8),
        color: theme.palette.error.main + '!important',
        fontSize: '0.9rem!important',
        textAlign: theme.errorText && theme.errorText.textAlign ? theme.errorText.textAlign : 'center!important'
    },
    formHelperText: {
        color: 'rgba(0, 0, 0, 0.81)',
        lineHeight: 1.2,
        padding: theme.spacing(0.5, 0.25),
        fontSize: '0.8rem',
        fontWeight: 500
    },
    questionWrapper: {
        marginTop: '0px!important'
    },
    [theme.breakpoints.down(600)]: {
        questionWrapper: {
            padding: '4px!important'
        }
    },
    textField: {
        '& fieldset': {
            border: theme.input ? theme.input.border + '!important' : null
        }
    },
    outlinedTextField: {
        '& input': {
            background: '#fff'
        }
    }
})

// Enhanced styles (for layout='full' only)
const enhancedStyles = theme => ({
    errorText: {
        marginTop: theme.spacing(0.8),
        color: '#dc2626!important',
        fontSize: '0.875rem!important',
        textAlign: 'left!important',
        fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    },
    formHelperText: {
        color: '#4a5d52',
        lineHeight: 1.4,
        padding: theme.spacing(0.75, 0.25),
        fontSize: '0.8rem',
        fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        fontWeight: 500
    },
    questionWrapper: {
        marginTop: '0px!important'
    },
    [theme.breakpoints.down(600)]: {
        questionWrapper: {
            padding: '4px!important'
        }
    },
    textField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            fontSize: '1rem',
            background: '#ffffff',
            transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
            '& fieldset': {
                borderColor: 'rgba(32, 90, 64, 0.2)',
                borderWidth: '1px',
            },
            '&:hover fieldset': {
                borderColor: 'rgba(32, 90, 64, 0.4)',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#205a40',
                borderWidth: '2px',
            },
            '&.Mui-focused': {
                boxShadow: '0 0 0 3px rgba(32, 90, 64, 0.1)',
            },
        },
        '& .MuiInputLabel-root': {
            fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            fontSize: '0.95rem',
            color: '#6a7d72',
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#205a40',
            fontWeight: 600,
        },
        '& .MuiOutlinedInput-input': {
            padding: '14px 16px',
        },
    },
    outlinedTextField: {
        '& input': {
            background: '#fff'
        }
    }
})

class TextQuestion extends Component {
    state = {}

    handleChange = event => {
        this.props.onValueChanged(this.props.question.id, event.target.value)
    }

    render() {
        const { classes, value, question, theme, layout } = this.props

        const inputValue = value ? value : ''
        return (
            <Grid item xs={parseInt(question.xsCols)} sm={parseInt(question.smCols)} className={classes.questionWrapper}>
                <TextField
                    required
                    label={question.title}
                    name={question.name}
                    fullWidth
                    variant={theme.inputVariant}
                    autoFocus={question.autoFocus}
                    onChange={this.handleChange}
                    error={question.valid === false}
                    value={inputValue}
                    className={
                        classes.textField +
                        ' inputText ' +
                        (theme.inputVariant === 'outlined' ? classes.outlinedTextField + ' outlinedInputText' : '')
                    }
                />
                {question.description && <FormHelperText className={classes.formHelperText}>{question.description}</FormHelperText>}
                {question.valid === false && (
                    <Grid item xs={12} style={{ paddingTop: 0 }}>
                        <FormHelperText className={classes.errorText}>{question.errorMessage}</FormHelperText>
                    </Grid>
                )}
            </Grid>
        )
    }
}

// Pre-create styled components at module level to prevent re-renders
const TextQuestionBase = withStyles(baseStyles)(TextQuestion);
const TextQuestionEnhanced = withStyles(enhancedStyles)(TextQuestion);

// Style switcher - returns pre-created components to prevent re-mounting
const TextQuestionWithStyles = (props) => {
    const { layout, ...rest } = props;
    
    if (layout === 'full') {
        return <TextQuestionEnhanced {...props} />;
    }
    return <TextQuestionBase {...props} />;
};

export default TextQuestionWithStyles;
